import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { StyledShopMap } from "./ListMap/StyledShopsMap";
import { StyledShopList } from "./Shop/StyledShop";
import { breakpoints } from "../../styles/utils/vars";
import { ButtonBase } from "../ui/Button/StyledButton";
export const cssButtonToggle = "cssButtonToggle_cd8mvp1";
export const cssModeMap = "cssModeMap_c1drcojw";
export const cssModeList = "cssModeList_c1t0h48m";
export const StyledStoresWrapper = /*#__PURE__*/styled('div')({
  name: "StyledStoresWrapper",
  class: "StyledStoresWrapper_s15dkgj4"
});

require("./StyledStoresPage.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledStoresPage.tsx");